import { useState } from "react";
import axios from "../utils/axiosInstance";

function SupportPage() {

  const [message,setMessage] = useState("");
  const [subject,setSubject] = useState("");

  const submitTicket = async(e)=>{
    e.preventDefault();

    try{

      await axios.post("/api/support",{
        subject,
        message
      });

      alert("Support request sent!");
      setSubject("");
      setMessage("");

    }catch(err){

      console.error(err);
      alert("Failed to send support request");

    }
  }

  return (

    <div className="max-w-3xl mx-auto p-10">

      <h1 className="text-3xl font-serif mb-6">
        Support
      </h1>

      <p className="text-gray-500 mb-8">
        Need help with your order or product? Send us a message.
      </p>

      <form
        onSubmit={submitTicket}
        className="space-y-4"
      >

        <input
          value={subject}
          onChange={(e)=>setSubject(e.target.value)}
          placeholder="Subject"
          className="w-full border p-3 rounded-lg"
          required
        />

        <textarea
          value={message}
          onChange={(e)=>setMessage(e.target.value)}
          placeholder="Your message..."
          className="w-full border p-3 rounded-lg h-40"
          required
        />

        <button
          className="bg-purple-600 text-white px-6 py-3 rounded-lg"
        >
          Send Message
        </button>

      </form>

    </div>

  );

}

export default SupportPage;